import axios from 'axios';

import { getSchedulingServerURL } from '../../HarverPages/shared/helper';

enum RequestedBy {
    recruiter = 'recruiter',
    candidate = 'candidate',
}

export function cancelInterview(
    calendarEventId: string,
    recruiterCancellationToken: string | null,
    reason: string,
    message: string,
) {
    const apiEndpoint = `${getSchedulingServerURL()}/interview/cancel`;
    const requestedBy = recruiterCancellationToken ? RequestedBy.recruiter : RequestedBy.candidate;

    return axios.post(apiEndpoint, { calendarEventId, reason, message, requestedBy, recruiterCancellationToken });
}
